import React from 'react'
import styles from './MetropoleHeader.module.css'

import image from './../../../../assets/images/title_welcome_montpellier.svg'
import svg from './../../../../assets/images/Logo-Ville-orange.svg'

const MetropoleHeader = () => {
  return (
    <header className={styles.header}>
      <div className={styles.contentContainer}>
        <div className={styles.textContainer}>
          <img
            src={image}
            alt="Bienvenue à Montpellier"
            className={styles.welcomeImage}
          />
        </div>

        <div className={styles.logoContainer}>
          {/* <div className={styles.logo}>
            <LogoMetropoleBasic />
          </div> */}
          <div className={styles.logo}>
            <img src={svg} alt="logo ville orange" />
          </div>
        </div>
      </div>
    </header>
  )
}

export default MetropoleHeader
